export class ParticipantAddRequest {
    outageId?: string | undefined;
    participants?: string[] | undefined;

    constructor(data?: ParticipantAddRequest) {
        this.outageId = data?.outageId;
        this.participants = data?.participants;
    }
}